/// <reference path="./types/bootstrap-5.d.ts" />
/// <reference path="./types/youtube-player.d.ts" />
export const COMPONENT_IMPORTERS = {
    accordion: () => import(
    /* webpackChunkName: "component.accordion" */ '@components/accordion'),
    'asset-slider': () => import(
    /* webpackChunkName: "component.asset-slider" */ '@components/asset-slider'),
    factoringtest: () => import(
    /* webpackChunkName: "component.factoringtest" */ '@components/factoringtest'),
    icons: () => import(
    /* webpackChunkName: "component.icons" */ '@components/icons'),
    leasingtest: () => import(
    /* webpackChunkName: "component.leasingtest" */ '@components/leasingtest'),
    portfolio: () => import(
    /* webpackChunkName: "component.portfolio" */ '@components/portfolio'),
    stage: () => import(
    /* webpackChunkName: "component.stage" */ '@components/stage'),
    'sticky-back-to-top': () => import(
    /* webpackChunkName: "component.sticky-back-to-top" */ '@components/sticky-back-to-top'),
    storytelling: () => import(
    /* webpackChunkName: "component.storytelling" */ '@components/storytelling'),
    'tab-text-image': () => import(
    /* webpackChunkName: "component.tab-text-image" */ '@components/tab-text-image'),
    'youtube-video': () => import(
    /* webpackChunkName: "component.youtube-video" */ '@components/youtube-video'),
};
export function getComponentImporter(name) {
    return Object.prototype.hasOwnProperty.call(COMPONENT_IMPORTERS, name)
        ? COMPONENT_IMPORTERS[name]
        : undefined;
}
